import formatPhoneNumber from "./formatPhoneNumber";
import getTelLink from "./getTelLink";
import sortPhoneNumbers from "./sortPhoneNumbers";
export default {
  formatPhoneNumber,
  getTelLink,
  sortPhoneNumbers
};
//# sourceMappingURL=index.js.map